import React from "react"
import PropTypes from "prop-types"

import {Button, ErrorMessage} from "../styled"
import { FileInput } from "./index"
import { PrivacyPolicyComponent } from "../index"

import {createMarkup} from "../../utils/Helpers"

export const UploadForm = ({instructions, handleSubmit, isSubmitting, errorMessage}) => {
  return (
    <div>
      <div dangerouslySetInnerHTML={createMarkup(instructions)} ></div>
      <FileInput />
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      <Button className="btn" id="btnSubmit" primary onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? "Uploading" : "Submit"}</Button>
      <PrivacyPolicyComponent />
    </div>
  )
}

UploadForm.propTypes = {
  instructions: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
}
